import { createStyles } from 'antd-style';

import { ThemeSpaces } from '../../theme';

export const useCopyToClipboardStyles = createStyles(() => ({
  tooltipWithNoArrow: {
    '&& .ant-tooltip-inner': {
      '&::before, &::after': {
        display: 'none',
      },
    },
  },
  copyToClipboardIcon: {
    '> *': {
      padding: `0 ${ThemeSpaces.SPACE_SM}px`,
    },
  },
  copyToClipboardHoverAreaAlwaysVisible: {
    '.CopyToClipboard-Icon': {
      visibility: 'visible',
    },
  },
  copyToClipboardHoverAreaShowOnHover: {
    '&:hover .CopyToClipboard-Icon': {
      visibility: 'visible',
    },

    '.CopyToClipboard-Icon': {
      '@media (hover: hover)': {
        visibility: 'hidden',
      },
      '@media (hover: none)': {
        visibility: 'visible',
      },
    },
  },
}));
